export default __webpack_public_path__ + "static/media/profile_img.b5ba33eb.png";